export default __webpack_public_path__ + "static/media/airlockz-wht-2.dc192b1e.png";